import { Link } from "react-router-dom";
import SiteLogo from "@/components/feature/SiteLogo";

const LINKS = [
  { label: "首页", path: "/" },
  { label: "漫画分类", path: "/category" },
  { label: "搜索漫画", path: "/search" },
  { label: "关于我们", path: "/about" },
];

export default function Footer() {
  return (
    <footer className="mt-auto bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div className="max-w-sm">
            <SiteLogo variant="inverse" />
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              老司机漫画，专注热门漫画连载与精彩章节推荐的中文阅读平台，涵盖热血、恋爱、奇幻、悬疑、科幻等丰富题材，陪你度过每一段追更时光。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4">站内导航</h4>
            <ul className="grid grid-cols-2 gap-2">
              {LINKS.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4">内容声明</h4>
            <p className="text-sm leading-relaxed text-background-300">
              本站所有漫画、章节、封面与评分为演示示例数据，仅用于界面展示，不代表任何真实作品或数据成就。
            </p>
            <div className="flex items-center gap-3 mt-4 text-background-400">
              <i className="ri-mail-line text-lg"></i>
              <span className="text-sm">feedback@laosiji-comic.demo</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © 2026 老司机漫画 · 本站为演示站点，内容仅供学习交流
          </p>
          <p className="text-xs text-background-400">
            禁止未经授权转载 · 演示数据不构成任何真实承诺
          </p>
        </div>
      </div>
    </footer>
  );
}